export const ROLE_SETTINGS_ROUTE = '/role';
export const ROLE_SETTING_FULL_CONSOLE_ACCESS = 'allowFullAdminConsoleAccess';
export const ROLE_SETTING_MODERATE_ALL_MEETINGS = 'moderateAllMeetings';
export const ROLE_SETTING_RECORD_MEETINGS = 'recordMeetings';
